<template>
  <BaseModal
    name="comission-affiliate"
    size="md"
    :title="$t('seller.affiliation.comission_affiliate.text_121')"
    @hidden="reset"
    @shown="openModal"
  >
    <div class="d-flex justify-content-center" v-if="loading">
      <b-spinner label="Loading..."></b-spinner>
    </div>

    <section class="container-arquivos" v-else>
      <div class="item-response" v-if="dados.affiliate">
        <p>{{ $t('seller.affiliation.comission_affiliate.text_1658') }}</p>
        <span>{{ dados.affiliate.name }}</span
        ><br />
        <span>{{ dados.affiliate.email }}</span>
      </div>

      <b-row v-if="dados.affiliate">
        <b-col cols="12" md="6" class="mt-2">
          <b-form-group :label="$t('seller.affiliation.comission_affiliate.text_1659')" label-for="comission">
            <money
              id="comission"
              name="comission"
              v-model="comission"
              placeholder="10,00"
              v-bind="formatPercentage"
            ></money>
            <b-form-invalid-feedback :state="errors.has('comission')" v-if="isInvalidValue(comission)">
              {{ $t("views.seller.edit_product.text_2367") }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <div v-if="!dados.affiliate" class="item-response">
        <span>{{ $t('seller.affiliation.comission_affiliate.text_122') }}</span>
      </div>
    </section>
    <template v-slot:footer="{ cancel }">
      <BaseButton
        :disabled="loading"
        variant="link-info"
        class="mr-4"
        @click="cancel"
      >
        {{ $t('seller.affiliation.comission_affiliate.text_1661') }}
      </BaseButton>

      <BaseButton variant="info2" :disabled="loading || isInvalidValue(comission)" @click="onSubmit">
        {{ $t('seller.affiliation.comission_affiliate.text_1662') }}
      </BaseButton>
    </template>
  </BaseModal>
</template>

<script>
import AffiliateService from "@/services/resources/AffiliateService";
import { Money } from "v-money";
const serviceAffiliate = AffiliateService.build();

export default {
  name: "ComissaoAfiliado",

  data() {
    return {
      formatPercentage: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        suffix: " %",
        precision: 2,
        masked: false,
      },
      loading: false,
      comission: 0,
    };
  },
  props: {
    dados: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    Money,
  },
  watch: {
    comission(value) {
      this.$nextTick(() => {
        if (value < 0.00) {
          this.comission = 0.01;
        } else if (value > 99.99) {
          this.comission = 99.99;
        }
      });
    }
  },
  methods: {
    isInvalidValue(value) {
      return value < 0.01 || !value;
    },
    openModal() {
      this.loading = true;
      this.comission = this.dados.comission || this.dados.product.comission;
      setTimeout(() => {
        this.loading = false;
      }, 1000);
    },

    reset() {
      this.comission = 0;
    },
    onSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.loading = true;
          let data = {
            product_id: this.dados.product_id,
            affiliate_id: this.dados.affiliate_id,
            comission: +this.comission,
          };

          serviceAffiliate
            .create(data, "/comission")
            .then((response) => {
              if (response.success) {
                this.$bvToast.toast(this.$t('seller.affiliation.comission_affiliate.text_123'), {
                  title: this.$t('seller.affiliation.comission_affiliate.text_1663'),
                  variant: "success",
                  autoHideDelay: 5000,
                  appendToast: true,
                });
              }
              this.$emit("close");
              this.$bvModal.hide("comission-affiliate");
              this.reset();
            })
            .catch((err) => {
              console.log(err);
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
  },
};
</script>

<style scoped>
p {
  margin: 0;
}
.item-response {
  margin-bottom: 10px;
}
.item-response p {
  color: #333;
  font-weight: 600;
  font-size: 15px;
  margin-bottom: 10px;
}
.item-response span {
  color: #81858e;
  font-size: 14px;
  margin: 7px 0;
}
</style>
